import { useContext } from 'react';
import { PropertyContext } from '../context/PropertyContext/PropertyContext';
export const useObjectId = () => useContext(PropertyContext).objectId;